import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CSEService } from '../../services/cse.service';
import { NotificationService } from '../../services/notification.service';
import {
    CarrierIncident,
    CarrierIncidentType
} from '../../models/models';

@Component({
    selector: 'carrier-incident-form',
    templateUrl: './carrier-incident-form.component.html',
    standalone: false
})
export class CarrierIncidentForm implements OnChanges {
    @Input() carrierIncidentID: number = 0;
    @Input() carrierID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public carrierIncident: CarrierIncident = {} as CarrierIncident;
    public carrierIncidentTypeList: CarrierIncidentType[] = [];
    public isLoading: boolean = false;

    constructor(private cseService: CSEService, private notificationService: NotificationService) {
    }

    ngOnInit() {
        this.getIncidentTypes();
        //console.log("ngOnInit", this.carrierIncidentID, this.carrierID);
    }

    ngOnChanges() {
        this.getCarrierIncident();
        //console.log("ngOnChanges", this.carrierIncidentID, this.carrierID);
    }

    private getIncidentTypes() {
        this.cseService.getCarrierIncidentTypes().subscribe(result => {
            this.carrierIncidentTypeList = result.resultCollection;
        });
    }

    private getCarrierIncident() {
        if (this.carrierIncidentID > 0) {
            this.cseService.getCarrierIncidentByID(this.carrierIncidentID).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.carrierIncident = result.resultCollection[0];
                }
            });
        }
        else {
            var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.carrierIncident = {
                carrierIncidentID: 0,
                carrierID: this.carrierID,
                carrierIncidentTypeID: 0,
                incidentDescription: "",
                createdByEmployeeId: employeeID,
                createdDate: new Date()
            };
        }
    }

    public save() {
        this.isLoading = true;
        console.log("save", this.carrierIncident);
        this.cseService.saveCarrierIncident(this.carrierIncident).subscribe(result => {
            this.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                this.onRefresh.emit();
            }
        });

        this.carrierIncident = {} as CarrierIncident;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}
